import { getAuthData } from '@common/helpers/auth';

export const maskPlayerName = (name) => {
  if (!name || name.length <= 2) return name;

  const parts = name.split(' ');
  const maskedParts = parts.map((part) => {
    if (part.length <= 2) return part;
    return `${part[0]}${'*'.repeat(part.length - 1)}`;
  });

  return maskedParts.join(' ');
};

export const getCurrencyConfig = () => ({
  name: getAuthData()?.currency,
  rate: 1,
  rounding: 2,
});

export const normalizeAmount = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 0;
  return numericValue > 0 ? numericValue : 0;
};

export const backStepNames = {
  0: 'close',
  1: 'back',
  2: 'back',
  3: 'close',
};

export const nextStepNames = {
  0: 'next',
  1: 'confirm',
  2: 'deposit',
  3: 'ok',
};
